export default __webpack_public_path__ + "static/media/Rupee.8bdd208e.svg";